<template>
  <div class="loading-wrap" :style="{'background-color': bg}">
    <img class="turn" style="width: 46px;height: 46px;" src="@/assets/images/loading.png" />
  </div>
</template>

<script>
export default {
  props: {
    bg: {
      type: String,
      default: 'rgba(255, 255, 255, 0.3)',
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.loading-wrap {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
}

.turn {
  animation: turn 1s linear infinite;
  position: absolute;
  left: 50%;
  top: 50%;
  background: none;
  margin-top: -23px;
  margin-left: -23px;
}

@keyframes turn {
  0% {
    -webkit-transform: rotate(0deg);
  }

  25% {
    -webkit-transform: rotate(90deg);
  }

  50% {
    -webkit-transform: rotate(180deg);
  }

  75% {
    -webkit-transform: rotate(270deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
</style>
